<template>
  <div class="containerForm" v-loading="formDataloading">
    <div class="head flex items-center">
      <i class="el-icon-document fileIcon"></i>
      <p class="font-bold">{{ $t("table.VesselInformation") }}</p>
    </div>
    <div class="form">
      <el-form ref="elForm" :model="formData" :rules="rules" size="small" :label-width="isMobileScreen ? null : '200px'"
        label-position="left" :disabled="!allowEditNomInfo">
        <el-form-item :label="'ID :'" prop="id">
          <el-input :disabled="true || !isCustomerAdmin" v-model="formData.id">
          </el-input>
        </el-form-item>
        <template v-if="isLogistics">
          <el-form ref="elCustomCodeForm" :model="formData" :rules="rules" size="small"
            :label-width="isMobileScreen ? null : '200px'" label-position="left" :disabled="elCustomCode">
            <el-form-item label="Ship To:" prop="customCode">
              <el-select size="small" v-model="formData.customCode" placeholder="Select ship to" clearable
                :disabled="!allowEditCustomCode" @change="handleUpdateCustomCode" style="width: 100%;">
                <el-option v-for="(option, index) in customCodeOptions" :key="index" :label="option.label"
                  :value="option.value" />
              </el-select>
            </el-form-item>
          </el-form>
        </template>
        <el-form-item :label="$t('table.customer') + ':'" prop="customerCompanyName">
          <el-input :disabled="true" v-model="formData.customerCompanyName">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('table.agent') + ':'" prop="alist">
          <el-select size="small" v-model="formData.alist" placeholder="" :style="{ width: '100%' }"
            :disabled="!isCustomerAdmin">
            <el-option v-for="(item) in agentOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('table.vesselEta') + ':'" prop="noEtas">
          <el-date-picker v-model="formData.noEtas" :picker-options="pickerOptions" prefix-icon="el-icon-date"
            type="datetime" :style="{ width: '100%' }" format="dd/MM/yyyy HH:mm:ss" value-format="dd/MM/yyyy HH:mm:ss"
            @change="covertToEpochTime" :disabled="!isCustomerAdmin">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('table.vessel') + ':'" prop="vesselName">
          <el-select v-model="formData.bargeName" clearable placeholder="Type here to search..." filterable
            bargeNameloading remote :remote-method="handleSearchBarge" class="bargeNameinput" @change="imochange"
            :loading="isBargeOptionsLoading" :disabled="!isCustomerAdmin" v-cancel-read-only>
            <el-option v-for="item in bargeoptions" :key="item.value" :disabled="item.unFlag == 1"
              :label="item.bargeName ? `${item.imo} (${item.bargeName})` : `${item.imo}`" :value="item.imo">
            </el-option>
          </el-select>
          <div v-if="mvpCompanyData"
            style="position: absolute; top: 0; right: 7px; display: flex; align-items: center; height: 100%">
            <img width="25" :src="iconOnlyImg" :title="'Company name: ' + mvpCompanyData.name" />
          </div>
        </el-form-item>
        <el-form-item :label="$t('table.surveyors') + ':'" prop="slist">
          <el-select size="small" v-model="formData.slist" multiple placeholder="" :style="{ width: '100%' }"
            :disabled="!isCustomerAdmin">
            <el-option v-for="(item) in surveyorOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="$t('table.block') + ':'" prop="blockNomination">
          <el-switch size="small" v-model="formData.block" :disabled="!isCustomerAdmin"
            @change="handleBlockChange"></el-switch>
        </el-form-item> -->
        <el-form-item :label="$t('table.remarks') + ':'" prop="remarks">
          <el-input size="small" v-model="formData.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }"
            :style="{ width: '100%' }" :disabled="!isCustomerAdmin"></el-input>
        </el-form-item>
        <el-form-item label="Hide Vessel Nomination from Terminal:"
          v-if="(userInfo.userType == 2 || userInfo.role == 5) && (Object.keys(createdtable).length < 1 || (createdtable.status == 0 || createdtable.status == 1))"
          class="formItemHideFromTerminal">
          <el-switch size="small" v-model="formData.hideFromTerminal" active-value="1" inactive-value="0"
            :disabled="!isCustomerAdmin"></el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div class="information" v-if="!isAgentRole">
      <div class="head" style="display: inline-flex; width: 100%;">
        <div style="display: inline-flex; width: 100%;">
          <i class="el-icon-document fileIcon"></i>
          <p class="title font-bold">{{ $t("table.Opeinfo") }} </p>
        </div>

        <el-button class="add-operation-button" v-if="!fromdisabled" plain type="primary" size="mini"
          @click="addOperation">{{
            $t("btn.addOperation") }}</el-button>
      </div>

      <operation-form v-for="(op, idx) in operations" ref="operationForms" :key="idx" :index="idx" :operation="op"
        :is-mobile-screen="isMobileScreen" :rules="rules" :formDisabled="fromdisabled" :operation-type="OperationType"
        :product-options="productOptions" :tank-options="tankOptions"
        :allowToChangeQuantity="allowToChangeQuantity(op.qtyRequestStatus)" :nom-qty="NomQty" @remove="removeOperation"
        @open-change-qty="openChangeQuantityDialog(op.id)" @open-change-tank="openChangeTankDialog(op.id)"
        @open-change-product="openChangeProductDialog(op.id)"
        :allowToChangeProduct="allowToChangeProduct(op.productRequestStatus)"
        :allowToChangeTank="allowToChangeTank(op.tankRequestStatus)" :doc-options="docOptions"
        @request-modification="handleRequestClick(op.id)" :showModifyButton="showRequestModifyButton()"
        :load-port-uploadable="canUploadLoadPort"
        :showRemove="!fromdisabled" />

    </div>
    <div class="information">
      <div class="head" style="display: inline-flex; width: 100%;">
        <div style="display: inline-flex; width: 100%;">
          <svg-icon iconClass="boat-two" />
          <p class="title font-bold">{{ $t("table.agentInfo") }} </p>
        </div>
      </div>

      <div class="mt-2">
        <el-form ref="elOperationForm" :model="agentInfoData" :rules="rules" size="small"
          :label-width="isMobileScreen ? null : '200px'" label-position="left" :disabled="!allowEditAgentInfo">
          <el-form-item :label="$t('table.vesselReadinessTime') + ':'" prop="vesselReadyTime">
            <el-date-picker v-model="agentInfoData.vesselReadyTime" :picker-options="pickerOptions"
              prefix-icon="el-icon-date" type="datetime" :style="{ width: '100%' }" format="dd/MM/yyyy HH:mm:ss"
              value-format="dd/MM/yyyy HH:mm:ss" @change="covertToEpochTime">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('table.typeofPilot') + ':'" prop="typeOfPilot" class="typeOfPilot">
            <el-select v-model="agentInfoData.typeOfPilot" placeholder="" clearable size="small"
              :style="{ width: '100%' }" @change="typeOfPilotChange(agentInfoData.typeOfPilot)">
              <el-option v-for="(item, index) in pilotOptions" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <span class="text" v-if="textvalidate" v-show="formData.blockNomination == '1' ? false : true">
              <p class="textb">
                Please ensure that the master is pilot exempted and that the vessel LOA is below 122 meter. Please
                produce
                a pilot exemption certificate when asked to.
              </p>
            </span>
          </el-form-item>
          <el-form-item :label="$t('table.contactNo') + ':'" prop="contactNumber">
            <vue-tel-input v-model="agentInfoData.contactNumber" mode="international" :style="{ width: '100%' }"
              :disabled="!allowEditAgentInfo" @input="onPSAContactNumberChange" required disabledFormatting
              validCharactersOnly></vue-tel-input>
            <div style="color: #f56c6c; font-size: 12px" v-if="PSAContactNumberIsValid == false">The contact number
              provided is invalid</div>
          </el-form-item>
        </el-form>

        <el-form :model="elinformaData" :rules="rules" size="small" :label-width="isMobileScreen ? null : '200px'"
          label-position="left" v-if="agentInfoData.typeOfPilot === 'PSA'" prop="pilotBerthTime"
          :disabled="!allowEditAgentInfo">
          <el-form-item :label="$t('table.pilotBerthTime') + ':'" prop="pilotBerthTime">
            <el-date-picker v-model="elinformaData.pilotBerthTime" prefix-icon="el-icon-date"
              format="dd/MM/yyyy HH:mm:ss" value-format="yyyy/MM/dd HH:mm:ss" type="datetime"
              :style="{ width: '100%' }">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-form :model="elinformaData" :rules="rules" size="small" :label-width="isMobileScreen ? null : '200px'"
          label-position="left" v-if="agentInfoData.typeOfPilot === 'PSA'" prop="pilotUnberthTime"
          :disabled="!allowEditPilotUnberthTime">
          <el-form-item :label="$t('table.pilotUnberthTime') + ':'" prop="pilotUnberthTime">
            <el-date-picker v-model="elinformaData.pilotUnberthTime" prefix-icon="el-icon-date"
              format="dd/MM/yyyy HH:mm:ss" value-format="yyyy/MM/dd HH:mm:ss" type="datetime"
              :style="{ width: '100%' }">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div :class="!textvalidate ? 'information' : 'mt-16'">
      <div class="flex head">
        <i class="el-icon-location-outline fileIcon"></i>
        <p class="title font-bold">{{ $t("table.jettyInformation") }} </p>
      </div>
      <div class="mt-2">
        <el-form ref="elinformaForm" :model="elinformaData" :rules="rules" size="small"
          :label-width="isMobileScreen ? null : '200px'" label-position="left">

          <el-form :model="elinformaData" :rules="rules" size="small" :label-width="isMobileScreen ? null : '200px'"
            label-position="left" :disabled="!(isLogistics && allowEditJettyInfo)">

            <el-form-item :label="'Estimated Jetty No :'" prop="estimatedJettyNo">
              <el-select v-model="elinformaData.estimatedJettyNo" clearable placeholder="" size="small"
                :style="{ width: '100%' }">
                <el-option v-for="(item, index) in jettyNoOptios" :key="index" :label="item.berthName"
                  :value="item.berthName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('table.estimatedBerthTiming') + ':'" prop="estimatedBerthTimings">
              <el-date-picker v-model="elinformaData.estimatedBerthTimings" prefix-icon="el-icon-date"
                format="dd/MM/yyyy HH:mm:ss" value-format="dd/MM/yyyy HH:mm:ss" type="datetime"
                :style="{ width: '100%' }" @change="onEstimatedBerthTimingChange">
              </el-date-picker>
            </el-form-item>
          </el-form>


          <el-form :model="elinformaData" :rules="rules" size="small" :label-width="isMobileScreen ? null : '200px'"
            label-position="left" :disabled="!(isCR && allowEditJettyInfo)">
            <el-form-item :label="$t('table.jettyNo') + ':'" prop="jettyNo">
              <el-select v-model="elinformaData.jettyNo" clearable placeholder="" size="small"
                :style="{ width: '100%' }">
                <el-option v-for="(item, index) in jettyNoOptios" :key="index" :label="item.berthName"
                  :value="item.berthName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('table.berthAssignTiming') + ':'" prop="berthAssignTimings">
              <el-date-picker v-model="elinformaData.berthAssignTimings" prefix-icon="el-icon-date"
                format="dd/MM/yyyy HH:mm:ss" value-format="dd/MM/yyyy HH:mm:ss" type="datetime"
                :style="{ width: '100%' }" @change="covertToEpochTime">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <el-form-item :label="$t('table.unberthTiming') + ':'" prop="unberthTiming">
            <el-date-picker v-model="elinformaData.unberthTiming" prefix-icon="el-icon-date"
              format="dd/MM/yyyy HH:mm:ss" value-format="dd/MM/yyyy HH:mm:ss" type="datetime" :style="{ width: '100%' }"
              @change="covertToEpochTime" :disabled="!allowEditUnberthTime">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="information">
      <div class="flex head">
        <i class="el-icon-ship fileIcon"></i>
        <p class="title font-bold">Fresh Water</p>
      </div>
      <div class="mt-2">
        <el-form ref="elFreshWaterForm" :model="elFreshWaterData" :rules="rules" size="small"
          :label-width="isMobileScreen ? null : '200px'" label-position="left">
          <el-form-item label="Fresh Water:" prop="freshWater">
            <el-switch size="small" v-model="elFreshWaterData.freshWater" :disabled="allowEditFreshWater"
              @change="$emit('change', elFreshWaterData.freshWater)" />
          </el-form-item>
          <el-form-item label="Fresh Water Available:" prop="freshWaterAvailable">
            <el-select v-model="elFreshWaterData.freshWaterAvailable" @change="updateWaterInput" placeholder="Select"
              size="mini" :style="{ width: '100%' }" :disabled="allowEditFreshWaterAvailable">
              <el-option v-for="item in freshWaterAvailableOptions" :key="item.id" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="Water Voucher:" prop="waterVoucher">
            <el-input v-model="elFreshWaterData.waterVoucher" :disabled="allowEditWaterVoucher" />
          </el-form-item>
          <el-form-item label="Water Meter:" prop="waterMeter">
            <el-input v-model="elFreshWaterData.waterMeter" :disabled="allowEditWaterVoucher" />
          </el-form-item>

        </el-form>
      </div>
    </div>
    <success-dialog v-on="$listeners" ref="successDialog" @upup="upup" />
    <checkBargeDialog ref="checkBargeDialog" @confirm="handleSureConfirm" :message="message"
      :isMobileScreen="isMobileScreen" />
    <el-dialog title="Send email for onboarding" :visible.sync="emailDialogVisible"
      :width="isMobileScreen ? '100%' : '500px'">
      <div>
        <el-form ref="emailForm" :model="emailData" :rules="emailRules" size="small" :label-width="'100px'"
          label-position="left">
          <el-form-item :label="'Email:'" prop="customerEmail">
            <el-input v-model="emailData.customerEmail" clearable size="small" :style="{ width: '100%' }"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="emailDialogVisible = false">{{ $t("btn.close")
            }}</el-button>
          <el-button type="primary" size="mini" @click="handleSendEmail">{{ $t("btn.submit") }}</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="Change quantity" :visible.sync="changeQuantityDialogVisible"
      :width="isMobileScreen ? '100%' : '500px'" @close="changeQuantityData.newNominatedQtyMax = null">
      <div>
        <p class="pb-2">After Submitting, the terminal will approve the change before it is updated in the vessel
          nomination</p>
        <el-form ref="changeQuantityForm" :model="changeQuantityData" :rules="changeQuantityRules" size="small"
          label-position="top">
          <el-form-item prop="changeQuantity">
            <template>
              <div><span style="color: red;">*</span>New Quantity</div>
              <el-input ref="qtys" oninput="value=value.replace(/[^\d]/g,'')"
                v-model="changeQuantityData.newNominatedQtyMax" clearable size="small" :style="{ width: '100%' }">
                <div slot="append">MT</div>
              </el-input>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="() => {
            changeQuantityDialogVisible = false;
            changeQuantityData.newNominatedQtyMax = null;
          }">{{ $t("btn.close")
            }}</el-button>
          <el-button type="primary" size="mini" @click="handleSubmitChangeQuantity">{{ $t("btn.submit") }}</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="Change Tank(s)" :visible.sync="changeTankDialogVisible" :width="isMobileScreen ? '100%' : '500px'"
      @close="changeTankData.newTankIds = null">
      <div>
        <p class="pb-2">
          After submitting, your change request will be sent for pending approval.
        </p>
        <el-form ref="changeTankForm" :model="changeTankData" :rules="changeTankRules" size="small"
          label-position="top">
          <el-form-item label="New Tank(s)" prop="newTankIds">
            <el-select v-model="changeTankData.newTankIds" placeholder="Select new tank(s)" clearable multiple
              style="width: 100%;">
              <el-option v-for="item in tankOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="() => {
            changeTankDialogVisible = false;
            changeTankData.newTankIds = null;
          }">{{ $t("btn.close")
            }}</el-button>
          <el-button type="primary" size="mini" @click="handleSubmitChangeTank">{{ $t("btn.submit") }}</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="Change Product" :visible.sync="changeProductDialogVisible"
      :width="isMobileScreen ? '100%' : '500px'" @close="changeProductData.newProduct = null">
      <div>
        <p class="pb-2">
          After submitting, your change request will be sent for pending approval.
        </p>
        <el-form ref="changeProductForm" :model="changeProductData" :rules="changeProductRules" size="small"
          label-position="top">
          <el-form-item label="New Product" prop="newProduct">
            <el-select v-model="changeProductData.newProduct" placeholder="Select new product" clearable
              style="width: 100%;">
              <el-option v-for="item in productOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="() => {
            changeProductDialogVisible = false;
            changeProductData.newProduct = null;
          }">{{ $t("btn.close")
            }}</el-button>
          <el-button type="primary" size="mini" @click="handleSubmitChangeProduct">{{ $t("btn.submit") }}</el-button>
        </div>
      </template>
    </el-dialog>
    <revocationDialog ref="revocationsDialog" :createdtable="createdtable" :isReasonDisabled="disableReason"
      @revocat="revocat" :isMobileScreen="isMobileScreen" :operation-id="activeOperationId" />
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import checkBargeDialog from "./check-vessel-dialog.vue";
import { searchBargeBer, resetBerthReason, getBargeContactNumberList, getAgentOptions } from '@/services/index';
import { searchBarge, updateNominatedQtyMax, requestProductUpdate, requestTankUpdate, updateCustomCode, updateAgentInfo, updateBerthInfo } from '@/services/user';
import moment from "moment";
import iconOnlyImg from "@/assets/icon-only.png";
import {
  getMvpCompany,
  Booknomination,
  formTankselect,
  JettyAll,
  formall,
  SendEmail,
  submitFreshWaterAvailable,
  createVesselNomination,
  updateVesselNomination
} from "@/services/user";
import { getSurveyoOptions } from "@/services";
import SuccessDialog from "@/components/common/success-dialog.vue";
import { mapState } from "vuex";
import { VueTelInput } from 'vue-tel-input';
import axios from "axios";
import { NomQty, OperationType } from "@/utils/constants";
import OperationForm from "../components/formComponents/OperationForm.vue";
import revocationDialog from "../components/revocation-dialog.vue";

export default {
  components: { SvgIcon, SuccessDialog, checkBargeDialog, VueTelInput, OperationForm, revocationDialog, },
  props: {
    // 船舶的传值
    createdtable: {
      type: Object,
      default() {
        return {};
      },
    },
    BargeData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 码头的传值
    terminaldatas: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      operations: [this.createDefaultOperation()],
      source: null,
      iconOnlyImg,
      bargeContactNumbers: [],
      tempJettyNo: '',
      emailData: { customerEmail: "" },
      formData: {
        customerCompanyName: "",
        noEta: "",
        bargeName: "",
        contact: "",
        balanceInTank: "",
        product: "",
        doc: "",
        block: false,
        blockNomination: "0",
        remarks: "",
        nominatedQtyMax: "",
        noEtas: "",
        vesselName: "",
        id: "",
        hideFromTerminal: "0",
        tlist: [],
        slist: [],
        alist: [],
        loadingType: null,
        jettyNo: "",
        status: 0,
        customCode: "Own warehouse bunker",
      },
      customCodeOptions: [
        { label: "Own warehouse bunker", value: "Own warehouse bunker" },
        { label: "Import", value: "Import" },
        { label: "Export", value: "Export" },
        { label: "3-Point", value: "3-Point" },
      ],
      userTypes: "",
      emailRules: {
        customerEmail: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
      },
      rules: {
        contact: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        pilotBerthTime: [],
        pilotUnberthTime: [],
        vesselEta: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        vesselReadyTime: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        noEtas: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        vesselName: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        balanceInTank: [
          {
            required: true,
            message: "",
            trigger: "blur",
          }
        ],
        nominatedQtyMax: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        nominatedQty: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        tlist: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        jettyNo: [
          {
            required: true,
            trigger: "change",
          },
        ],

        product: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        tankDetails: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        slist: [],
        alist: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        doc: [],
        remarks: [],
        typeOfPilot: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        contactNumber: [
          {
            required: true,
            trigger: "blur",
          },
        ],

      },
      bargeoptions: [],
      productOptions: [
        {
          label: "LSFO",
          value: "LSFO",
        },
        {
          label: "FO380",
          value: "FO380",
        },
        {
          label: "LSMGO",
          value: "LSMGO",
        },
        {
          label: "FO500",
          value: "FO500",
        },
        {
          label: "FO180",
          value: "FO180",
        },
        {
          label: "HSMGO",
          value: "HSMGO",
        },
        {
          label: "B24 VLSFO",
          value: "B24 VLSFO",
        },
        {
          label: "BIO-MGO",
          value: "BIO-MGO",
        },
      ],
      surveyorOptions: [],
      agentOptions: [],
      docOptions: [
        {
          label: "CQ",
          value: "CQ",
        },
        {
          label: "BL",
          value: "BL",
        },
      ],
      agentInfoData: {
        bargeReadiness: null,
        typeOfPilot: "PSA",
        contactNumber: "",
        bargeContactNumber: "",
        bargeContactNumbers: null,
        id: "",
        vesselReadyTime: "",
      },
      elinformaData: {
        jettyNo: "",
        berthAssignTiming: "",
        berthAssignTimings: "",
        estimatedBerthTiming: "",
        estimatedBerthTimings: "",
        id: "",
        pilotBerthTime: "",
        pilotUnberthTime: "",
        unberthTiming: "",
        estimatedJettyNo: "",
      },
      elinformaDataFromRes: {
        jettyNo: "",
        berthAssignTiming: "",
        berthAssignTimings: "",
        estimatedBerthTiming: "",
        estimatedBerthTimings: "",
        id: "",
        pilotBerthTime: "",
        pilotUnberthTime: "",
        unberthTiming: "",
        estimatedJettyNo: "",
      },
      pilotOptions: [
        {
          label: "PSA",
          value: "PSA",
        },
        {
          label: "IHP",
          value: "IHP",
        },
      ],
      jettyNoOptios: [],
      isEdit: true,
      showOperationInput: true,
      showJettyInput: true,
      formVisible: 0,
      academyData: [],
      timeout: null,
      fromdisabled: false,
      OperationFormVisible: true,
      contactdisabled: false,
      userTypes: "",
      elvisible: false,
      Jettyelvisible: true,
      barges: "",
      shipinfos: {},
      // 模糊搜索
      bargeNameloading: false,
      // 提示文字信息
      textvalidate: false,
      // form船舶loading
      isBargeOptionsLoading: true,
      // formloading
      formDataloading: false,
      message: "",
      mvpCompanyData: null,
      tankOptions: [],
      surveyorOptions: [],
      agentOptions: [],
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      PSAContactNumberIsValid: null,
      emailDialogVisible: false,
      changeQuantityDialogVisible: false,
      activeOperationId: null,
      changeQuantityData: {
        id: null,
        newNominatedQtyMax: null,
        operationId: null,
      },
      changeTankDialogVisible: false,
      changeProductDialogVisible: false,
      changeTankData: {
        id: null,
        newTankIds: null,
        operationId: null,
      },
      changeProductData: {
        id: null,
        newProduct: null,
        operationId: null,
      },
      changeQuantityRules: {
        newNominatedQtyMax: [
          {
            required: true,
            message: "The field is required",
            trigger: "blur",
          },
        ],
      },
      elFreshWaterData: {
        freshWater: false,
        freshWaterAvailable: null,
        waterVoucher: "",
        waterMeter: "",
        id: "",
      },
      elFreshWaterDataFromRes: {
        freshWater: false,
        freshWaterAvailable: null,
        waterVoucher: "",
        waterMeter: "",
        id: "",
      },
      freshWaterAvailableOptions: [
        { id: 0, value: 0, label: 'Not Selected', },
        { id: 1, value: 1, label: 'Yes', },
        { id: 2, value: 2, label: 'No', },
      ],
      grt: null,
      bargeContactNumberList: [],
      disableReason: false,
      activeOperationId: null,
    };
  },
  watch: {
    createdtable() {
      this.Setrloe();
      this.GetselectList();
    },
    'formData.block': {
      immediate: true,
      handler(newValue) {
        this.formData.blockNomination = newValue ? '1' : '0';
      },
    },
    'formData.blockNomination': {
      immediate: true,
      handler(newValue) {
        this.formData.block = newValue === '1';
      },
    },
  },
  created() {
    this.Setrloe();
    this.GetselectList();
    if (this.$route.query.id) {
      this.formDataloading = true;
      this.getdatalist();
    }
  },
  directives: {
    cancelReadOnly(el) {
      const input = el.querySelector('.el-input__inner');
      input.removeAttribute('readonly');
    }
  },
  computed: {
    allowEditFreshWater() {
      const isBargeRole = this.$store.state.userInfo.role === '8';
      const isJettyAssigned = this.createdtable.status == 2 && this.createdtable.loadingType == null;
      return !(isBargeRole && isJettyAssigned);
    },
    allowEditFreshWaterAvailable() {
      const isLoadingRole = this.$store.state.userInfo.role === '11';
      const isCCRRole = this.$store.state.userInfo.role === '2';
      const isCompleted = this.createdtable.status == 4 && this.createdtable.loadingType == 8;
      const isCancelled = this.createdtable.status == 5;
      return !((isLoadingRole || isCCRRole) && !isCompleted && !isCancelled) || this.elFreshWaterData.freshWater !== true;
    },
    allowEditWaterVoucher() {
      const isLoadingRole = this.$store.state.userInfo.role === '11';
      const isCCRRole = this.$store.state.userInfo.role === '2';
      const isCompleted = this.createdtable.status == 4 && this.createdtable.loadingType == 8;
      const isCancelled = this.createdtable.status == 5;
      return !((isLoadingRole || isCCRRole) && !isCompleted && !isCancelled) || this.elFreshWaterData.freshWater !== true || this.elFreshWaterData.freshWaterAvailable !== 1;
    },
    NomQty() {
      return NomQty;
    },
    OperationType() {
      return OperationType;
    },
    ...mapState(["userInfo", "screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
    isCustomerAdmin() {
      return this.userInfo?.role == 5;
    },
    bargeImo: function () {
      if (this.formData.bargeName) return this.formData.bargeName;
      return null;
    },
    allowEditCustomCode() {
      return this.userRoles == 1 && this.createdtable.status !== 5;
    },
    isCustomer() {
      return this.userInfo?.userType == 2;
    },
    isAgent() {
      return (this.userInfo?.userType == 5 || this.userInfo?.userType == "5") && this.userInfo?.role != 14 ;
    },
    // agent user (role 15) and agent company/admin (role 14) — all agent accounts
    isAgentRole() {
      return this.userInfo?.userType == 5 || this.userInfo?.userType == "5";
    },
    // customer can upload load-port documents only while Created or Vessel Ready (or when creating a new nom)
    canUploadLoadPort() {
      const status = this.createdtable ? this.createdtable.status : undefined;
      const isCreate = !this.createdtable || Object.keys(this.createdtable).length < 1 || status === undefined || status === null;
      return this.isCustomer && (isCreate || status == 0 || status == 1);
    },
    isLogistics() {
      return this.userInfo?.role == "1" || this.userInfo?.role == 1;
    },
    isCR() {
      return this.userInfo?.role == 2;
    },
    allowEditUnberthTime() {
      return this.isCR && (this.createdtable.status == 3 || this.createdtable.status == 2) && (this.createdtable.loadingType == 0 || this.createdtable.loadingType == 8 || this.createdtable.loadingType == 6 || this.createdtable.loadingType == 4);
    },
    allowEditPilotUnberthTime() {
      return this.isAgent && (this.createdtable.status == 3 || this.createdtable.status == 2) && (this.createdtable.loadingType == 0 || this.createdtable.loadingType == 8 || this.createdtable.loadingType == 6 || this.createdtable.loadingType == 4);
    },
    allowEditAgentInfo() {
      return this.isAgent && (this.createdtable.status == 0 || this.createdtable.status == 1 || this.createdtable.status == 2) && this.createdtable.loadingType == null;
    },
    allowEditJettyInfo() {
      return (this.createdtable.status == 0 || this.createdtable.status == 1 || this.createdtable.status == 2) && (this.createdtable.loadingType == null || this.createdtable.loadingType == 0) && (this.isLogistics || this.isCR);
    },
    allowEditNomInfo() {
      return this.createdtable.id ? this.createdtable.status == 0 || this.createdtable.status == 1 : true;
    },

  },
  methods: {
    showRequestModifyButton() {
      return this.createdtable.status == 4 && this.userInfo.role == 5
    },

    allowToChangeQuantity(qtyRequestStatus) {
      return this.userInfo?.role == 5 && qtyRequestStatus !== true &&
        (
          this.createdtable.status === 4 && this.createdtable.loadingType === 8
        )
    },
    allowToChangeTank(tankRequestStatus) {
      return this.userInfo?.role == 5 && tankRequestStatus !== true &&
        (this.createdtable.status === 4 && this.createdtable.loadingType === 8)
    },
    allowToChangeProduct(changeProductRequestStatus) {
      return this.userInfo?.role == 5 && changeProductRequestStatus !== true &&
        (
          this.createdtable.status === 4 && this.createdtable.loadingType === 8
        )
    },
    async validateAllOperationForms() {
      let valid = true;
      const refs = Array.isArray(this.$refs.operationForms)
        ? this.$refs.operationForms
        : [this.$refs.operationForms];

      for (const formRef of refs) {
        if (formRef && formRef.$refs && formRef.$refs[`elOperationForm${formRef.index}`]) {
          const result = await new Promise(resolve => {
            formRef.$refs[`elOperationForm${formRef.index}`].validate(resolve);
          });

          if (!result) {
            valid = false;
          }
        }
      }
      return valid;
    },
    timeFormatter(val) {
      if (!val) {
        return null;
      }

      let a = val.split("/");
      let b = a[2].slice(0, 4);
      let d = a[2].slice(4);
      let c = b + "/" + a[1] + "/" + a[0] + d;

      return new Date(c).valueOf();
    },
    handleBlockChange(value) {
      this.formData.block = value;
      this.formData.blockNomination = value ? '1' : '0';
    },
    // phone-number format check for the agent Contact Number (same as barge nom)
    onPSAContactNumberChange(value, phoneObject) {
      this.PSAContactNumberIsValid = phoneObject && phoneObject.valid == true;
    },
    // true if any discharge operation has no load-port document
    isMissingLoadPortDoc() {
      return (this.operations || []).some((op) => {
        const isDischarge = op.operationType == 1 || op.operationType === "1" || op.operationType === "Discharge";
        return isDischarge && !(op.loadPortDocuments && op.loadPortDocuments.length > 0);
      });
    },
    createDefaultOperation() {
      return {
        id: '',
        nominatedQtyMax: '',
        qtyType: "Min",
        tlist: [],
        tankRequestStatus: false,
        product: '',
        doc: '',
        remarks: '',
        typeOfPilot: 'PSA',
        operationType: "Loading",
        attachments: [],
        loadPortDocuments: [],
        tankDetails: [],
        qtyRequestStatus: false,
        tankRequestStatus: false,
        productRequestStatus: false,
        requestStatus: false,
        requestReason: "",
        newNominatedQtyMax: null,
        newTank: null,
        newProduct: null,
      };
    },
    addOperation() {
      this.operations.push(this.createDefaultOperation());
    },
    removeOperation(index) {
      this.operations.splice(index, 1);
    },
    updateWaterInput(index) {
      if (index == 1) {
        this.elFreshWaterData.waterVoucher = this.elFreshWaterDataFromRes.waterVoucher;
        this.elFreshWaterData.waterMeter = this.elFreshWaterDataFromRes.waterMeter === "No water meter available" ? "" : this.elFreshWaterDataFromRes.waterMeter;
      } else if (index == 0) {
        this.elFreshWaterData.waterVoucher = "";
        this.elFreshWaterData.waterMeter = "";
      } else if (index == 2) {
        this.elFreshWaterData.waterVoucher = "";
        this.elFreshWaterData.waterMeter = "No water meter available";
      }
    },
    async handleSubmitFreshWaterAvailable() {
      const data = { ...this.elFreshWaterData };
      delete data.freshWater;
      await submitFreshWaterAvailable(data).then(res => {
        if (res.code == 200) {
          this.$message.success('Save Fresh Water Detail Success');
        }
      });
    },

    tankName(id) {
      const match = this.tankOptions.find(t => t.value === id);
      return match ? match.label : id; // Fallback to ID if not found
    },
    noEtaInSeconds: function () {
      if (typeof this.formData.noEtas == "string" && this.formData.noEtas) {
        return moment(this.formData.noEtas, "DD/MM/YYYY hh:mm:ss").unix();
      } else if (typeof this.formData.noEta == "string" && this.formData.noEta) {
        return moment(this.formData.noEta, "DD/MM/YYYY hh:mm:ss").unix();
      } else if (typeof this.formData.noEta == "number" && this.formData.noEta) {
        return this.formData.noEta / 1000;
      } else {
        return null;
      }
    },
    handleImoChange(imo) {
      if (this.source) {
        this.source.cancel();
      }
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();

      let timestamp = this.noEtaInSeconds();

      if (imo == null || timestamp == null || isNaN(timestamp)) return;

      this.mvpCompanyData = null;

      getMvpCompany({ imo, timestamp, cancelToken: this.source.token })
        .then(res => {
          this.mvpCompanyData = res.data;
          this.$message.success("Account found in Marine Vessel Pass: " + this.mvpCompanyData.name);
        }).catch((e) => {
          this.emailDialogVisible = true
        });
    },
    handleSureConfirm() {
      if (this.effectCallback) {
        this.effectCallback();
        this.$refs.checkBargeDialog.close();
      }
    },
    handleUpdateCustomCode() {
      const payload = {
        id: this.formData.id,
        customCode: this.formData.customCode,
      };
      updateCustomCode(payload)
        .then((res) => {
          this.$message.success("Ship To updated successfully!");
        })
        .catch((err) => {
          this.$message.error("Failed to update Ship To");
        });
    },
    Setrloe() {
      this.userTypes = this.$store.state.userInfo.userType;
      this.userRoles = this.$store.state.userInfo.role;
      if (this.createdtable.status == 5) {
        this.fromdisabled = true;
      } else {
        if (this.userTypes == 4) {
          this.agentInfoData.id = this.createdtable.id;
          this.fromdisabled = true;
          this.OperationFormVisible = false;
          this.elvisible = this.createdtable.blockNomination >= '2';
        }
        if (this.userTypes == 5) {
          this.agentInfoData.id = this.createdtable.id;
          this.fromdisabled = true;
          this.OperationFormVisible = false;
          this.elvisible = this.createdtable.blockNomination >= '2';
        }
        if (this.userTypes == 1) {
          if (
            this.$store.state.userInfo.role == 2 &&
            (this.createdtable.status == 1 || this.createdtable.status == 2)
          ) {
            this.Jettyelvisible = false;
          }
          this.elvisible = true;
          this.fromdisabled = true;
        }
        if (this.userTypes == 2) {
          this.OperationFormVisible = false;
          this.elvisible = true;
          if (this.createdtable.status === 4 && this.createdtable.status === 5) {
            this.fromdisabled = true;
          } else {
            this.fromdisabled = false;
          }
          if (this.$store.state.userInfo.role == 4) {
            this.fromdisabled = true;
          }
        }
        // Admin (role 0) is view-only on operations
        if (this.userRoles == 0) {
          this.fromdisabled = true;
        }
        if (this.$route.query.id) {
          this.formDataloading = true;
          this.getdatalist();
        } else {
          this.formData.customerCompanyName = this.$store.state.userInfo.companyName
        }
      }

    },
    getdatalist() {
      formall(this.$route.query.id).then(async (res) => {
        this.contactdisabled = res.data.typeOfPilot === 'PSA';
        Object.keys(this.formData).forEach((key) => {
          if (res.data[key] !== undefined) {
            this.formData[key] = res.data[key];
          }

        });

        const data = { bargeName: this.formData.bargeName };
        const bargenumberlist = await getBargeContactNumberList(data);
        if (bargenumberlist?.data.contactNumber?.length > 0) {
          this.bargeContactNumbers = bargenumberlist.data.contactNumber.map(c => ({
            contactNumber: c,
            phoneNumberIsValid: true,
          }));
        }
        if (res.data.bargeContactNumber) {
          this.bargeContactNumbers = res.data.bargeContactNumber.split(",").map(c => ({
            contactNumber: c,
            phoneNumberIsValid: true,
          }));
        }

        if (!this.bargeoptions.some(item => item.imo === this.formData.bargeName)) {
          searchBarge(this.formData.bargeName).then(res => {
            if (res.data?.length) {
              this.bargeoptions.push(res.data[0]);
            }
          });
        }

        this.bargeoptions.forEach(item => {
          if (item.imo === this.formData.bargeName) {
            const timestamp = this.noEtaInSeconds();
            if (this.source) {
              this.source.cancel();
            }
            const CancelToken = axios.CancelToken;
            this.source = CancelToken.source();
            getMvpCompany({ imo: item.imo, timestamp, cancelToken: this.source.token })
              .then(res => {
                this.mvpCompanyData = res.data;
              });
          }
        });
        this.formData.noEtas = res.data.noEta;
        this.formData.slist = res.data?.slistNomination?.map((tank) => {
          return tank.sid;
        })

        this.agentInfoData.vesselReadyTime = res.data.bargeReadiness
          ? moment(res.data.bargeReadiness).format("DD/MM/YYYY HH:mm:ss")
          : "";

        if (this.tankOptions?.length < 1 && res.data.tlistNomination != null && res.data.tlistNomination.length > 0) {
          this.tankOptions = res.data.tlistNomination.map((item) => {
            return {
              label: item.tankNumber,
              value: item.tid
            }
          });
        }
        if (res.data.vesselOperations && res.data.vesselOperations.length > 0) {
          this.operations = res.data.vesselOperations.map((op) => ({
            id: op.id,
            operationType: op.operationType,
            qtyType: op.nominatedQtyType,
            nominatedQty: op.nominatedQtyMax,
            tlist: op.tanks || [],
            tankDetails: op.operationTanks?.map((tank) => ({
              id: tank.id,
              tankName: tank.tankName,
              tankNumber: tank.tankNumber,
            })) || [],
            product: op.product,
            doc: op.doc,
            remarks: op.remarks,
            attachments: op.operationFiles?.map((file) => ({
              id: file.id,
              name: file.originalFileName || `file_${file.id}.pdf`,
              raw: null,
              documentUrl: file.documentUrl || file.path,
              createTime: file.createTime || new Date().toLocaleString(),
            })) || [],
            loadPortDocuments: op.loadPortFiles?.map((file) => ({
              id: file.id,
              name: file.originalFileName || `file_${file.id}.pdf`,
              raw: null,
              documentUrl: file.documentUrl || file.path,
              createTime: file.createTime || new Date().toLocaleString(),
            })) || [],
            qtyRequestStatus: op.qtyRequestStatus || false,
            tankRequestStatus: op.tankRequestStatus || false,
            productRequestStatus: op.productRequestStatus || false,
            requestStatus: op.requestStatus || false,
            requestReason: op.requestReason || "",
            newNominatedQtyMax: op.newNominatedQtyMax || null,
            newTank: op.newTank || null,
            newProduct: op.newProduct || null,
          }));
        }

        this.grt = res.data.grt
        this.shipinfos.lengthOverall = res.data.lengthOverall
        this.shipinfos.imo = res.data.bargeName
        this.$emit("shipinfos", this.shipinfos);
        if (
          this.$store.state.userInfo.userType == 4 && res.data.blockNomination < '2'
        ) {

          this.elvisible = false;
        } else {
          this.elvisible = true;
        }
        Object.keys(this.agentInfoData).forEach((key) => {
          if (res.data[key]) {
            this.agentInfoData[key] = res.data[key];
            this.agentInfoData.pilotBerthTime = res.data.pilotBerthingTime;
            this.agentInfoData.pilotUnberthTime = res.data.pilotUnberthingTime;
            this.agentInfoData.vesselReadyTime = res.data.bargeReadiness;
          }
        });
        // 控制船舶填写权限
        if (
          (res.data.status == 1 || res.data.status == 2) &&
          this.$store.state.userInfo.userType == 1 &&
          this.$store.state.userInfo.role == 2
        ) {
          this.modifyJettyInformationPermission();
        } else {
          this.Jettyelvisible = true;
        }
        Object.keys(this.elinformaData).forEach((key) => {
          this.elinformaData[key] = res.data[key];
          this.elinformaData.berthAssignTimings = res.data.berthAssignTiming;
          this.elinformaData.estimatedBerthTimings = res.data.estimatedBerthTiming;
          this.elinformaData.vesselReadyTime = res.data.bargeReadiness
          this.elinformaData.pilotBerthTime = res.data.pilotBerthingTime;
          this.elinformaData.pilotUnberthTime = res.data.pilotUnberthingTime;
          this.elinformaData.unberthTiming = res.data.unberthTiming;
          this.elinformaData.estimatedJettyNo = res.data.estimatedJettyNo;

        });
        Object.keys(this.elinformaDataFromRes).forEach((key) => {
          this.elinformaDataFromRes[key] = this.elinformaData[key];
        });

        Object.keys(this.elFreshWaterData).forEach((key) => {
          if (res.data[key]) {
            this.elFreshWaterData[key] = res.data[key];
            this.elFreshWaterData.freshWater = res.data.freshWater;
          }
        });
        Object.keys(this.elFreshWaterDataFromRes).forEach((key) => {
          this.elFreshWaterDataFromRes[key] = this.elFreshWaterData[key];
        });
        this.tempJettyNo = this.elinformaData.jettyNo
        this.formDataloading = false;
        this.modifyBargeInformationPermission();
        if (this.userTypes === "2") {
          if (this.createdtable.status === 4 && this.createdtable.loadingType === 8) {
            this.fromdisabled = true;
          } else if (this.createdtable.status === 5 && this.createdtable.loadingType === null) {
            this.fromdisabled = true;
          } else {
            this.fromdisabled = false;
          }
        }

        this.formDataloading = false;
        this.formData.qtyRequestStatus = res.data.qtyRequestStatus ?? false;
        this.formData.tankRequestStatus = res.data.tankRequestStatus ?? false;
        this.formData.productRequestStatus = res.data.productRequestStatus ?? false;
        this.formData.newTank = res.data.newTank ?? null;
        this.formData.newProduct = res.data.newProduct ?? null;
        this.formData.newNominatedQtyMax = res.data.newNominatedQtyMax ?? null;
        this.formData.alist = res.data.agentCompanyId ?? null;
        this.formData.block = res.data.blockNomination == '1' ? true : false;

      });

      if (this.createdtable.typeOfPilot == "IHP") {
        this.textvalidate = true;
      } else {
        this.textvalidate = false;
      }
    },
    GetselectList() {
      formTankselect().then((res) => {
        if (res.code == 200 && res.data !== null && res.data?.length > 0) {
          this.tankOptions = res.data.map((item) => {
            return {
              label: item.tankNumber,
              value: item.id
            }
          });
        }
      });
      JettyAll().then((res) => {
        if (res.code == 200) {
          this.jettyNoOptios = res.rows;
        }
      });
      getSurveyoOptions().then((res) => {
        if (res.code == 200 && res.data !== null && res.data.length > 0) {
          this.surveyorOptions = res.data.map((item) => {

            return {
              label: item.nickName,
              value: item.userId
            }
          });
        }

      });
      getAgentOptions().then((res) => {
        if (res.code == 200 && res.data !== null && res.data.length > 0) {
          this.agentOptions = res.data.map((item) => {
            return {
              label: item.nickName,
              value: item.userId
            }
          });
        }

      });
    },
    async handleBerthAssignment(data, callback) {
      const unassignBerth = async () => {
        let res = await updateVesselNomination(data);
        if (res.code == 200) {
          callback()
          this.tempJettyNo = this.elinformaData.jettyNo
        }
      }
      if (!this.Jettyelvisible && this.elinformaData.jettyNo != null && this.elinformaData.jettyNo.trim() == '' && this.tempJettyNo.trim() != '') {
        try {
          await this.$prompt('Reason', 'Unassign Berth', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputType: 'textarea',
            inputPattern: /^(?!\s*$).+/,
            inputErrorMessage: 'Reason is required',
            closeOnClickModal: false,
          })
            .then(({ value }) => {
              resetBerthReason({ bid: this.formData.id, remark: value }).then(() => {
                unassignBerth()
              });
            })
            .catch(() => { });
        } catch (error) {
          this.$emit("loading", "3")
        }
      } else {
        unassignBerth()
      }
    },
    combineInputs() {
      const bargingNominationJson = {
        customerCompanyName: this.formData.customerCompanyName,
        agentCompanyName: this.agentOptions.find(agent => agent.value === this.formData.alist)?.label || "",
        agentCompanyId: this.formData.alist || null,
        noEta: this.timeFormatter(this.formData.noEtas) ?? null,
        bargeName: this.formData.bargeName,
        contact: this.formData.contact,
        balanceInTank: this.formData.balanceInTank,
        product: this.formData.product,
        doc: this.formData.doc,
        block: this.formData.block || false,
        blockNomination: this.formData.blockNomination,
        remarks: this.formData.remarks,
        nominatedQtyMax: this.formData.nominatedQtyMax,
        noEtas: this.formData.noEtas,
        vesselName: this.formData.vesselName,
        id: this.formData.id,
        hideFromTerminal: this.formData.hideFromTerminal,
        tlist: [],
        slist: this.formData.slist,
        loadingType: null,
        jettyNo: this.formData.jettyNo,
        status: this.formData.status,
        customCode: this.formData.customCode,
        qtyRequestStatus: this.formData.qtyRequestStatus,
        tankRequestStatus: this.formData.tankRequestStatus,
        productRequestStatus: this.formData.productRequestStatus,
        lengthOverall: sessionStorage.getItem('lengthOverall'),
        grt: this.grt || "",
        vesselOperations: this.operations.map(op => ({
          id: op.id ?? undefined,
          operationType: (op.operationType == 1 || op.operationType === "1" || op.operationType === "Discharge") ? "Discharge" : "Loading",
          nominatedQtyMax: op.nominatedQty,
          tanks: op.tlist,
          product: op.product,
          doc: op.doc,
          nominatedQtyType: op.qtyType,
          remarks: op.remarks,
        })),

      };
      const formData = new FormData();
      formData.append("bargingNominationJson", JSON.stringify(bargingNominationJson));
      if (this.userTypes == "2" && this.$route.query.id) {
        const deleteFileIds = this.operations
          .map(op => op.deleteFileIds)
          .filter(ids => ids && ids.length > 0)
          .join(",");
        formData.append("deletedFileIds", deleteFileIds || "");
      }

      this.operations.forEach((op, index) => {
        const fileKey = `files_${String(index + 1).padStart(2, '0')}`;
        if (op.attachments && op.attachments.length > 0) {
          op.attachments.forEach((file) => {
            if (file.raw) {

              formData.append(fileKey, file.raw);
            } else if (file.documentUrl) {

              formData.append(fileKey, file.documentUrl);
            }
          });
        } else {
          formData.append(fileKey, "");
        }

        // load-port documents (discharge only) — only newly added files (raw) are uploaded
        const loadPortKey = `loadPortFiles_${String(index + 1).padStart(2, '0')}`;
        const newLoadPortFiles = (op.loadPortDocuments || []).filter((f) => f.raw);
        if (newLoadPortFiles.length > 0) {
          newLoadPortFiles.forEach((file) => formData.append(loadPortKey, file.raw));
        } else {
          formData.append(loadPortKey, "");
        }
      });
      return formData;

    },
    async submitForm(callback) {
      this.combineInputs();
      if (this.userTypes == "5") {
        this.$refs["elOperationForm"].validate((valid) => {
          if (!valid) return;
          if (this.PSAContactNumberIsValid === false) {
            this.$message.error("The contact number provided is invalid");
            return;
          }
          console.log("Valid form data for agent:", valid);
          callback();

          const requestBody = {
            bargeReadiness: moment(this.agentInfoData.vesselReadyTime, "DD/MM/YYYY hh:mm:ss").valueOf(),
            typeOfPilot: this.agentInfoData.typeOfPilot ?? "",
            contactNumber: this.agentInfoData.contactNumber ?? "",
            bargeContactNumber: this.agentInfoData.bargeContactNumbers
              ? this.agentInfoData.bargeContactNumbers.map((c) => c.contactNumber).join(",")
              : "",
            bargeContactNumbers: this.agentInfoData.bargeContactNumbers || [],
            freshWater: this.elFreshWaterData.freshWater ?? false,
            id: this.formData.id,
            lengthOverall: sessionStorage.getItem("lengthOverall")
              ? sessionStorage.getItem("lengthOverall")
              : this.shipinfos.lengthOverall,
            pilotBerthingTime: this.elinformaData.pilotBerthTime
              ? this.elinformaData.pilotBerthTime.replace(/\//g, '-')
              : null,
            pilotUnberthingTime: this.elinformaData.pilotUnberthTime
              ? this.elinformaData.pilotUnberthTime.replace(/\//g, '-')
              : null,
          };

          updateAgentInfo(requestBody)
            .then((res) => {
              if (res.code === 200) {
                this.$refs.successDialog.open();
                this.$refs.successDialog.message =
                  "Agent information modified successfully!";
                // stay on the current page (refresh via upup), do not navigate to the list
                this.$refs.successDialog.userAdd = "";
              }
            })
            .catch((err) => {
              console.error("Error submitting agent information:", err);
              this.$message.error("Error submitting agent information.");
            });
        });
      }
      if (this.userTypes == "4") {
        this.elFreshWaterData.freshWater = this.elFreshWaterData.freshWater
        this.$refs["elOperationForm"].validate((valid) => {
          if (this.PSAContactNumberIsValid == false) {
            return this.$message.error("Invalid PSA Contact Number");
          }

          if (this.bargeContactNumbers.length > 0) {
            var phoneNumberIsValid = false;
            var result = [];
            this.bargeContactNumbers.forEach((el) => {
              result.push(el.contactNumber);
              phoneNumberIsValid = el.phoneNumberIsValid;
            })
            if (!phoneNumberIsValid) return alert('Please check the provided contact numbers');
            this.agentInfoData.bargeContactNumber = result.join(",");
            this.agentInfoData.bargeContactNumbers = this.bargeContactNumbers;
          }

          if (this.bargeContactNumbers.length == 0) {
            this.agentInfoData.bargeContactNumber = "";
            this.agentInfoData.bargeContactNumbers = null;
          }

          if (this.agentInfoData.contactNumber) {
            this.agentInfoData.contactNumber = this.agentInfoData.contactNumber;
          }

          if (!valid) return;
          callback();

          const requestBody = {
            bargeReadiness: moment(this.agentInfoData.vesselReadyTime, "DD/MM/YYYY hh:mm:ss").valueOf(),
            typeOfPilot: this.agentInfoData.typeOfPilot ?? "",
            contactNumber: this.agentInfoData.contactNumber ?? "",
            bargeContactNumber: this.agentInfoData.bargeContactNumbers
              ? this.agentInfoData.bargeContactNumbers.map((c) => c.contactNumber).join(",")
              : "",
            bargeContactNumbers: this.agentInfoData.bargeContactNumbers || [],
            freshWater: this.elFreshWaterData.freshWater ?? false,
            id: this.formData.id,
            lengthOverall: sessionStorage.getItem("lengthOverall")
              ? sessionStorage.getItem("lengthOverall")
              : this.shipinfos.lengthOverall,
            pilotBerthingTime: this.elinformaData.pilotBerthTime
              ? this.elinformaData.pilotBerthTime.replace(/\//g, '-')
              : null,
            pilotUnberthingTime: this.elinformaData.pilotUnberthTime
              ? this.elinformaData.pilotUnberthTime.replace(/\//g, '-')
              : null,
          };

          updateAgentInfo(requestBody)
            .then((res) => {
              if (res.code === 200) {
                this.$emit("loading", "1");
                this.$message.success("Fresh water submitted succesfully");
                this.getdatalist();
              }
            })
            .catch((err) => {
              console.error("Error submitting fresh water:", err);
              this.$message.error("Failed to submit fresh water.");
            });
        });
      }
      if (this.userTypes == "2") {
        if (this.$route.query.id) {
          this.formData.id = this.$route.query.id;
          this.agentInfoData.id = this.$route.query.id;
          this.elinformaData.id = this.$route.query.id;
          const mainValid = await new Promise(resolve => {
            this.$refs["elForm"].validate(resolve);
          });

          const operationValid = await this.validateAllOperationForms();

          if (!mainValid || !operationValid) {
            this.$message.error("Please complete all required fields in the forms.");
            return;
          } else {
            callback();
            updateVesselNomination(this.combineInputs())
              .then((res) => {
                if (res.code === 200) {
                  this.$refs.successDialog.open();
                  this.$refs.successDialog.message =
                    "Vessel Nomination modified successfully!";
                  // stay on the current page (refresh via upup), do not navigate to the list
                  this.$refs.successDialog.userAdd = "";
                }
              })
              .catch((err) => {
                console.error("Error saving data:", err);
                this.$message.error("Failed to save changes.");
              });
          }

        } else {
          const mainValid = await new Promise(resolve => {
            this.$refs["elForm"].validate(resolve);
          });
          const operationValid = await this.validateAllOperationForms();

          if (!mainValid || !operationValid) {
            this.$message.error("Please complete all required fields in the forms.");
            return;
          } else {
            callback();
            createVesselNomination(
              this.combineInputs()
            )
              .then((res) => {
                if (res.code == 200) {
                  this.$refs.successDialog.open();
                  this.$refs.successDialog.message =
                    "Vessel Nomination created successfully!";
                  // click Close on the dialog -> go back to the vessel nomination list
                  this.$refs.successDialog.userAdd = 2;
                  this.$emit("loading", "1");
                }
              })
              .catch((error) => {
                if (error.toString() == 'Error: Selected ship not active in Marine Vessel Pass (MVP). Please contact admin for onboarding.') {
                  this.emailDialogVisible = true
                }
                this.$emit("loading", "3");
              });
          }

        }
      }
      if (this.userTypes == "1") {
        const freshWaterChange = JSON.stringify(this.elFreshWaterData) !== JSON.stringify(this.elFreshWaterDataFromRes)
        const jettyInfoChange = JSON.stringify(this.elinformaData) !== JSON.stringify(this.elinformaDataFromRes)
        if (this.userInfo.role == "11" && freshWaterChange) {
          this.handleSubmitFreshWaterAvailable()
          callback();
          return;
        }
        if (this.userInfo.role == "2" && !jettyInfoChange && freshWaterChange) {
          this.handleSubmitFreshWaterAvailable()
          callback();
          return;
        }
        if (this.userInfo.role == "2" && freshWaterChange) {
          this.handleSubmitFreshWaterAvailable()
        }
        if ((this.userInfo.role == "1" || this.userInfo.role == "2") && jettyInfoChange) {
          // Before assigning a berth, every discharge operation must have at least one load-port document
          if (this.elinformaData.jettyNo && this.isMissingLoadPortDoc()) {
            this.$alert(
              "This nomination has a discharge operation without a Load Port document. Please ask the customer to upload at least one Load Port document before assigning the berth.",
              "Load Port Document Required",
              { type: "warning", confirmButtonText: "OK" }
            );
            return;
          }
          this.$refs["elinformaForm"].validate((valid) => {
            if (!valid) return;
            callback();
            const requestBody = {
              jettyNo: this.elinformaData.jettyNo,
              berthAssignTiming: this.timeFormatter(this.elinformaData.berthAssignTimings ?? null),
              berthAssignTimings: this.elinformaData.berthAssignTimings ?? null,
              estimatedBerthTiming: this.timeFormatter(this.elinformaData.estimatedBerthTimings ?? null),
              estimatedBerthTimings: this.elinformaData.estimatedBerthTimings ?? null,
              id: this.formData.id,
              lengthOverall: sessionStorage.getItem('lengthOverall') ? sessionStorage.getItem('lengthOverall') : this.shipinfos.lengthOverall,
              unberthTiming: this.elinformaData.unberthTiming ?? null,
              estimatedJettyNo: this.elinformaData.estimatedJettyNo ?? null,
            };

            this.requestBody = JSON.stringify(requestBody);
            updateBerthInfo(requestBody)
              .then((res) => {
                if (res.code === 200) {
                  this.$refs.successDialog.show = true;
                  this.$refs.successDialog.message =
                    "Information submitted successfully!";
                  this.$emit("loading", "1");
                }
              })
              .catch((err) => {
                this.$emit("loading", "3");
                console.error("Error saving data:", err);
              });
          })
        }
      }
    },
    handleSendEmail() {
      this.$refs["emailForm"].validate((valid) => {
        if (valid) {
          SendEmail(this.emailData).then(res => {
            this.emailDialogVisible = false
          })
        }
      })
    },
    async imochange() {
      this.agentInfoData = {};
      this.textvalidate = false;
      this.handleImoChange(this.bargeImo);
      this.bargeoptions.forEach((item) => {
        if (item.imo == this.bargeImo) {
          this.shipinfos = item;
          this.formData.vesselName = item.bargeName;
          this.grt = item.grossTonnageGt;
        }
      });
      const data = { "bargeName": this.bargeImo }
      const res = await getBargeContactNumberList(data)
      this.bargeContactNumbers = res.data.contactNumber.map(c => ({
        contactNumber: c,
        phoneNumberIsValid: true,
      }));
      this.$emit("shipinfos", this.shipinfos);
    },
    // 表单时间函数
    covertToEpochTime(val) {
      if (!val) {
        return;
      }

      let a = val.split("/");
      let b = a[2].slice(0, 4);
      let d = a[2].slice(4);
      let c = b + "/" + a[1] + "/" + a[0] + d;

      const epochTime = new Date(c).valueOf();

      if (this.userTypes === "1") {
        this.elinformaData.berthAssignTiming = epochTime;
      }

      if (this.userTypes === "5") {
        this.elinformaData.unberthTiming = epochTime;
      }
    },

    onEstimatedBerthTimingChange(val) {
      if (!val) {
        this.elinformaData.estimatedBerthTiming = null;
        this.elinformaData.estimatedBerthTimings = null;
        return;
      }
      if (this.userTypes == 1) {
        this.elinformaData.estimatedBerthTimings = val;
      }
    },

    // 船舶表单控制
    typeOfPilotChange(val) {
      val == "PSA" ? (this.contactdisabled = true) : (this.contactdisabled = false);
      val == "IHP" ? (this.textvalidate = true) : (this.textvalidate = false);
      if (val == "IHP") {
        this.agentInfoData.contactNumber = ""
        this.PSAContactNumberIsValid = true
      }
    },
    upup() {
      if (this.userTypes == 4) {
        this.$emit("upup", "4");
      }
      if (this.userTypes == 2) {
        this.$emit("upup", "2");
      }
      if (this.userTypes == 1) {
        this.$emit("upup", "1");
      }
    },
    async handleSearchBarge(query) {
      if (query !== '') {
        this.isBargeOptionsLoading = true;
        try {
          const res = await searchBarge(query);
          this.bargeoptions = res.data;
        } catch (error) {
          this.bargeoptions = [];
        } finally {
          this.isBargeOptionsLoading = false;
        }
      } else {
        this.bargeoptions = [];
      }
    },
    allowChangeBarge() {

      return this.userTypes == 2 && this.$store.state.userInfo.role == 5 && this.createdtable.status > 0;
    },
    modifyBargeInformationPermission() {
      // if block nomination is booked, all barge's  information can not modify
      if (this.formData.blockNomination >= "2") {
        this.fromdisabled = true
      }
    },
    modifyJettyInformationPermission() {
      this.Jettyelvisible = true
      if (this.formData.status <= 3) {
        if (this.formData.blockNomination < "2") {
          this.Jettyelvisible = false
        } else if (this.formData.blockNomination == "2" && (this.formData.loadingType == null || this.formData.loadingType < 4)) {
          this.Jettyelvisible = false
        }
      }
    },
    disabledDate(date) {
      const currentDate = new Date();
      return date < currentDate.setDate(currentDate.getDate() - 1);
    },
    async handleSubmitChangeQuantity() {
      this.$refs["changeQuantityForm"].validate(async (valid) => {
        if (valid) {
          this.changeQuantityData.id = this.createdtable.id
          await updateNominatedQtyMax(this.changeQuantityData).then(res => {
            const activeOperation = this.operations.find(op => op.id == this.changeQuantityData.operationId);
            activeOperation.qtyRequestStatus = true;
            activeOperation.newNominatedQtyMax = this.changeQuantityData.newNominatedQtyMax;
            this.changeQuantityDialogVisible = false
          })
        }
      })
    },
    async handleSubmitChangeTank() {
      this.$refs["changeTankForm"].validate(async (valid) => {
        if (valid) {
          const payload = {
            nominationId: this.createdtable.id,
            tankIds: this.changeTankData.newTankIds,
            operationId: this.changeTankData.operationId,
          };
          await requestTankUpdate(payload)
            .then(() => {
              const activeOperation = this.operations.find(op => op.id == this.changeTankData.operationId);
              activeOperation.tankRequestStatus = true;
              activeOperation.newTank = this.changeTankData.newTankIds
                .map(id => this.tankName(id))
                .join(', '); // Add this
              this.changeTankDialogVisible = false;
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    },
    async handleSubmitChangeProduct() {
      this.$refs["changeProductForm"].validate(async (valid) => {
        if (valid) {
          const payload = {
            id: this.createdtable.id,
            product: this.changeProductData.newProduct,
            operationId: this.changeProductData.operationId,
          };
          await requestProductUpdate(payload)
            .then(() => {
              const activeOperation = this.operations.find(op => op.id == this.changeProductData.operationId);
              activeOperation.productRequestStatus = true;
              activeOperation.newProduct = this.changeProductData.newProduct;
              this.changeProductDialogVisible = false;
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    },

    openChangeQuantityDialog(operationId) {
      this.changeQuantityData.newNominatedQtyMax = this.formData.newNominatedQtyMax ?? this.formData.nominatedQtyMax;
      this.changeQuantityData.id = this.createdtable.id;
      this.changeQuantityData.operationId = operationId
      this.$nextTick(() => {
        this.$refs.changeQuantityForm?.clearValidate();
        this.changeQuantityDialogVisible = true;
      });
    },
    openChangeTankDialog(operationId) {
      this.changeTankData.operationId = operationId;
      if ((!this.changeTankData.newTankIds || this.changeTankData.newTankIds.length === 0) && this.formData.newTank) {
        this.changeTankData.newTankIds = this.formData.newTank
          .split(',')
          .map(t => t.trim())
          .map(tank => {
            const match = this.tankOptions.find(opt => opt.label === tank);
            return match ? match.value : tank;
          });
      }

      this.$nextTick(() => {
        this.$refs.changeTankForm?.clearValidate();
        this.changeTankDialogVisible = true;
      });
    },
    openChangeProductDialog(operationId) {
      this.changeProductData.operationId = operationId;
      if (!this.changeProductData.newProduct && this.formData.newProduct) {
        const match = this.productOptions.find(opt => opt.label === this.formData.newProduct);
        this.changeProductData.newProduct = match ? match.value : this.formData.newProduct;
      }

      this.$nextTick(() => {
        this.$refs.changeProductForm?.clearValidate();
        this.changeProductDialogVisible = true;
      });
    },

    handleRequestClick(operationId) {
      // Show the dialog
      this.$refs.revocationsDialog.show = true;
      this.activeOperationId = operationId;
      this.disableReason = this.operations.find(op => op.id === operationId).requestStatus === 1;


      // CASE 1: Request for Modification
      if (this.createdtable.status == 4) {
        this.$refs.revocationsDialog.message = "Request for Modification";
        this.$refs.revocationsDialog.label = "Reason";
        this.$refs.revocationsDialog.confirmvisible = true;

        const activeOperation = this.operations.find(op => op.id === operationId);
        // Only prefill if request already made
        if (activeOperation.requestStatus === 1) {
          this.$refs.revocationsDialog.formDate.reason =
            this.createdtable.reason || this.reasons || "";
        } else {
          this.$refs.revocationsDialog.formDate.reason = "";
        }
      }

      // CASE 2: Cancel Nomination
      else {
        this.$refs.revocationsDialog.message = "Confirm to cancel vessel nomination?";
        this.$refs.revocationsDialog.label = "Reason for cancelling";
        this.$refs.revocationsDialog.confirmvisible = true;

        // Prefill if it was previously requested
        if (this.isRequest) {
          this.$refs.revocationsDialog.formDate.reason =
            this.createdtable.reason || this.reasons || "";
        } else {
          this.$refs.revocationsDialog.formDate.reason = "";
        }
      }
    },
    revocat(val) {
      this.cancelVesselBtn = false;
      this.has;
      this.submitbtn = false;
      if (val?.reason) {
        this.reasons = val.reason;
        this.CommitBtnvisible = false;
      }
      if (val) {
        this.hasShowRequestCancel = true;
      }
      if (!this.isRequest) {
        this.operations.find(op => op.id === this.activeOperationId).requestStatus = 1;
        this.disableReason = true;
      }
      getlist();
    },
  },
};
</script>

<style lang="scss" scoped>
.containerForm {
  padding: 10px 26px;
  background: #fff;

  .head {
    padding-bottom: 6px;
    border-bottom: 1px solid #d5dded;

    >.fileIcon {
      font-size: 20px;
    }

    >p {
      color: #4c565c;
      margin-left: 10px;
      font-size: 13px;
    }
  }

  .form {
    margin-top: 10px;
  }
}

::v-deep.bargeNameinput {
  width: 100%;

  .el-input__inner {
    color: #2e5efd !important;
  }
}

::v-deep .el-form-item--medium .el-form-item__label {
  color: #82889c;
  font-size: 12px;
}

::v-deep .el-input-group__append {
  background: #82889c;
  border-radius: 0px 1px 1px 0px;
  font-size: 12px;
  text-align: center;

  color: #ffffff;
}

::v-deep .el-switch {
  transform: scale(1.2);
}

.information {
  margin-top: 30px;
  flex-direction: row;

  .head {
    padding-bottom: 8px;
    border-bottom: 1px solid #d5dded;
  }

  .svg-icon {
    width: 38px;
    height: 22px;
  }

  .title {
    color: #4c565c;
    margin-left: 9px;
    font-size: 13px;
  }

  .fileIcon {
    font-size: 20px;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: white !important;
    color: #000 !important;
    cursor: auto !important;
  }
}

.formItemText {
  font-size: 12px;
  color: #82889c;
}

::v-deep .el-input--small .el-input__inner {
  height: 28px;
}

::v-deep .el-input--small textarea {
  height: 60px !important;
  min-height: 60px !important;
}

.typeOfPilot {
  position: relative;

  .text {
    width: 100%;
    font-size: 10px;
    color: #ff0000;

    .textb {
      line-height: 14px;
    }
  }
}

::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 5px;
}

::v-deep .el-form-item--small .el-form-item__label {
  line-height: 28px;
}

::v-deep .el-form-item__error {
  color: transparent;
}

::v-deep .formItemHideFromTerminal {
  .el-form-item__content {
    margin-left: 0 !important;

    .el-checkbox__label {
      font-weight: normal;
    }
  }
}

::v-deep .vue-tel-input.disabled {
  background-color: #f5f7fa !important;
}

::v-deep .vue-tel-input.disabled input {
  background-color: #f5f7fa !important;
}

.operation-text {
  margin-top: 10px;
  margin-bottom: 10px;
}

.line {
  flex-grow: 1;
  height: 1px;
  background-color: #ccc;
  margin-right: 10px;
  margin-left: 10px;
}

.el-input.is-disabled .el-input__inner {
  background-color: white !important;
  color: #000 !important;
  cursor: auto !important;
}

::v-deep .add-operation-button:hover {
  background-color: white !important;
  border-color: #409EFF !important;
  color: #409EFF !important;
  opacity: 0.5;
}

::v-deep .add-operation-button {
  background-color: white !important;
  border-color: #409EFF !important;
  color: #409EFF !important;
}
</style>
